import { render } from "./GutRelatedQuestions.vue?vue&type=template&id=50b3be49&scoped=true"
import script from "./GutRelatedQuestions.vue?vue&type=script&lang=js"
export * from "./GutRelatedQuestions.vue?vue&type=script&lang=js"

import "./GutRelatedQuestions.vue?vue&type=style&index=0&id=50b3be49&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b3be49"]])

export default __exports__